<template>

    <v-card>
        <v-card-title
          class="text_primary pb-4"
        >
          {{ page_title }}

          <v-spacer></v-spacer>
          <v-btn
            class="mr-2 white--text"
            color="#5087e6"
            @click="createSetting"
          >
            新增
          </v-btn>

        </v-card-title>

        <v-divider></v-divider>
        <v-row class="mt-1 mb-1 pr-3">
          <v-col
            cols="12"
            lg="8"
            md="12"
            xs="12"
          >
          <v-card-text
            class="d-flex align-center justify-end pt-0 pr-0 pb-0"
          >
            <v-text-field
              dense
              outlined
              v-model="search"
              append-icon="mdi-magnify"
              label="搜尋 名稱 / 網址"
              single-line
              hide-details
              @keypress.enter="searchKeyword(search)"
            ></v-text-field>
          </v-card-text>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="12"
            xs="12"
          >  
            <v-card-text
              class="d-flex align-center justify-end pa-0"
            >
              <p class="mb-0 pb-0 mr-3">顯示</p>
              <v-select
                style="max-width:7em;"
                outlined
                return-object
                @change="chagePerPage(selected_per_page)"
                v-model="selected_per_page"
                :items="per_page_items"
                item-value="value"
                item-text="name"
                hide-details
                dense
              >
              </v-select>
            </v-card-text>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-tabs
            show-arrows
            center-active
            v-model="tab_setting.tab"
            color="primary"
        >
            <v-tab 
                @click="changeTab(item)" 
                v-for="(item) in tab_setting.modes" 
                :key="item.id"
            >      
                {{ item.title }}
            </v-tab>
        </v-tabs>

        <v-data-table
          :loading="loading"
          :loading-text="loading_text"
          :no-data-text="'尚未有衝動外掛。'"
          :no-results-text="'尚未有衝動外掛。'"
          :headers="headers"
          :items="items"
          hide-default-footer
        >
          <template v-slot:[`item.name`] = "{ item }">
            <div
              class="table-row-pointer table-truncate"
              @click="viewSetting(item)"
            >
              {{item.name}}
            </div>
          </template>

          <template v-slot:[`item.url`] = "{ item }">
            <div
              class="d-flex align-center "
            >
              <div
                class="table-truncate mr-3"
                style="cursor:text;"
              >
                {{ decodeURIComponent(decodeURIComponent(item.url)) }}
              </div>
              <v-icon 
                small
                @click="$utils.openURL(item.url)"
              >
                mdi-open-in-new
              </v-icon>
            </div>
          </template>

          <template v-slot:[`item.start_at`] = "{ item }">
              {{$utils.displayISOString(item.start_at) }}
          </template>

          <template v-slot:[`item.end_at`] = "{ item }">
              {{$utils.displayISOString(item.end_at) }}
          </template>
          
          <template v-slot:[`item.actions`] = "{item}">

            <v-btn
              class="text_default btn_default btn_default_bg_linear mr-3"
              outlined
              @click="viewSetting(item)"
            >
              檢視
            </v-btn>

            <v-btn
              class="btn_action btn_action_bg_linear"
              outlined
              @click="copyUrlView(item)"
            >
              複製
            </v-btn>

            <v-btn
              :color="$vuetify.theme.themes['dark']['warning']"
              class="ml-3 btn-danger"
              outlined
              @click="deleteSetting(item)"
            >
              刪除
            </v-btn>


            
          </template>
        </v-data-table>

      <div class="text-center mt-5">
        <Pagination
          @changePage="changePageCallback"
          v-if="page_setting.is_show"
          :setting="page_setting"
        />
      </div>

      <v-dialog
        v-model="dialog"
        width="900"
      >
        <v-card>

          <v-card-title class="text-h5 primary white--text">
            新增衝動外掛
          </v-card-title>

          <div v-if="is_duplicate" class="mb-2 pt-4 pb-0 pl-6 pr-6">
            <v-alert
              outlined
              type="warning"
              prominent
              border="left"
            >
              偵測到此頁面有啟用中的實驗/插件，請調整時間區間避免和以下實驗/插件衝突
            </v-alert>

            <div class="mb-2" v-for="(settings, setting_key) in duplicate_setting" :key="setting_key">
              <h3 v-if="settings.length > 0" class="mb-2 pb-0 ">{{setting_key_map[setting_key].name}}:</h3>
              <v-card v-if="settings.length > 0">
                <v-data-table
                  :headers="setting_key_map[setting_key].headers"
                  :items="settings"
                  hide-default-footer
                  :items-per-page="settings.length"
                >
                  <template v-slot:[`item.name`] = "{ item }">
                    <div
                      class="table-row-pointer table-truncate"
                      @click="viewInfo(item, setting_key, item[setting_key_map[setting_key].field_map.id])"
                    >
                      {{item.name}}
                    </div>
                  </template>
                  <template v-slot:[`item.start_at`] = "{ item }">
                    {{ $utils.displayISOString(item.start_at) }}
                  </template>
                  <template v-slot:[`item.end_at`] = "{ item }">
                    {{ $utils.displayISOString(item.end_at) }}
                  </template>
                </v-data-table>
              </v-card>
            </div>

          </div>

          <v-divider class="mb-2 mt-4" v-if="is_duplicate"></v-divider>

          <v-card-text eleavtion="0" class="pt-5">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col
                  cols="12"
                  lg="12"
                  md="12"
                  xs="12"
                  class="pb-0"
                >
                  <h5
                    class="subtitle-2 pa-0"
                  >
                    {{config.name.text}}
                    <span
                      class="error-message"
                    >(必填)</span>
                  </h5>

                  <v-text-field
                    outlined
                    dense
                    class="pa-0 ma-0 "
                    v-model="config.name.value"
                    :rules="[rules.required]"
                    validate-on-blur
                    :hint="'設定名稱，幫助你來辨認'"
                  >
                  </v-text-field>
                </v-col> 
              </v-row>

              <v-row
                class="mt-0"
              >
                <v-col
                  cols="12"
                  lg="12"
                  md="12"
                  xs="12"
                  class="pt-0 pb-0"
                >
                  <h5
                    class="subtitle-2 pa-0"
                  >
                    {{config.url.text}}
                    <span
                      class="error-message"
                    >(必填)</span>
                  </h5>
                  <v-text-field
                    outlined
                    dense
                    class="pa-0 ma-0 "
                    v-model="config.url.value"
                    :rules="[rules.required, rules.validateUrl]"
                    validate-on-blur
                    :hint="'在哪個網址要顯示，例如: https://www.example.com/products/product_a'"
                  >
                  </v-text-field>
                </v-col> 
              </v-row>
            </v-form>
            <v-row
              class="mt-0"
            >
              <v-col
                cols="12"
                lg="6"
                md="6"
                xs="6"
                class="pt-0 pb-0"
              >
                <h5
                  class="subtitle-2 pa-0"
                >
                  {{config.start_at.text}}
                  <span
                    class="error-message"
                  >(必填)</span>
                </h5>
                <div>
                  <date-picker 
                    :shortcuts="$utils.date_picker_shorcuts"
                    style="width:100%;"
                    v-model="config.start_at.value" 
                    type="datetime"
                    value-type="format" 
                    format="YYYY-MM-DD HH:mm:ss"
                  >        
                  </date-picker>
                  <div>
                    <small class="error-message pl-3">{{config.start_at.message}}</small>
                  </div>
                </div>
              </v-col> 
              <v-col
                cols="12"
                lg="6"
                md="6"
                xs="6"
                class="pt-0 pb-0"
              >
                <h5
                  class="subtitle-2 pa-0"
                >
                  {{config.end_at.text}}
                  <span
                    class="error-message"
                  >(必填)</span>
                </h5>
                <div>
                  <date-picker 
                    :shortcuts="$utils.date_picker_shorcuts"
                    :disabled-date="disableEndtAt"
                    style="width:100%;"
                    v-model="config.end_at.value" 
                    type="datetime"
                    value-type="format" 
                    format="YYYY-MM-DD HH:mm:ss"
                  >        
                  </date-picker>
                  <div>
                    <small class="error-message pl-3">{{config.end_at.message}}</small>
                  </div>
                </div>
              </v-col> 
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="confirmCreateSetting()"
            >
              新增
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card>
    
</template>

<script>
// DatePicker!
import {
  apiOverlaySetting,
  apiCreateSetting,
  apiDeleteSetting,
  apiCopyUrlView
} from '@/api/urlview.js'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'
import Pagination from '@/components/Utils/Pagination.vue'
import {
	apiGetSetting
} from '@/api/urlview.js'

  export default {
    name: 'SaleCounterList',
		components: {
			Pagination,
      DatePicker
		},
    data: function(){
      return {

        // 頁面名稱
        page_title: "衝動外掛",

        // items
        items: [],

        headers: [
          { text: '名稱', value: 'name', sortable: false,},
          { text: '網址', value: 'url', sortable: true,},
          { text: '開始時間', value: 'start_at', sortable: false},
          { text: '結束時間', value: 'end_at', sortable: false},
          { text: '', value: 'actions', sortable: false },
        ],

        search: '',

				page_setting: {
					is_show: false,
					selected_page: 1,
					total_page: 10,
					total_visible: 10,
				},
				selected_per_page: {
					name: "10筆",
					value: 10, 
				},
				per_page_items: [
					{
						name: "10筆",
						value: 10, 
					},
					{
						name: "24筆",
						value: 24, 
					},
					{
						name: "48筆",
						value: 48, 
					},
					{
						name: "100筆",
						value: 100, 
					},
				],

        dialog: false,
        is_duplicate: false,
        duplicate_setting: {
          experience: [],
          urlview: []
        },
        setting_key_map: {
          experience: {
            name: '實驗',
            headers: [
              { text: '名稱', value: 'name', sortable: false,},
              { text: '開始時間', value: 'start_at', sortable: false,},
              { text: '結束時間', value: 'end_at', sortable: false,},
            ],
            field_map: {
              id: "experience_id",
              name: 'name'
            }
          },
          urlview: {
            name: '插件',
            headers: [
              { text: '名稱', value: 'name', sortable: false,},
              { text: '開始時間', value: 'start_at', sortable: false,},
              { text: '結束時間', value: 'end_at', sortable: false,},
            ],
            field_map: {
              id: "experience_id",
              name: 'name'
            }
          },
        },
        config: {
          name: {
            text: "名稱",
            value: "",
          },
          url: {
            text: "網址",
            value: "",
          },
          start_at: {
            text: "開始顯示時間",
            value: "",
            message: "",
          },
          end_at: {
            text: "結束顯示時間",
            value: "",
            message: "",
          },
          campaign_start_at: {
            text: "活動開始時間",
            value: "",
            message: "",
          },
          campaign_end_at: {
            text: "活動結束時間",
            value: "",
            message: "",
          }
        },
        rules: this.$utils.field_rules,
        same_checkbox: false,
        loading: false,
        loading_text: '載入中',
        tab_setting: {
          tab: null,
          default_tab: {
              id: 'all',
              title: '全部'
          },
          tab_name_mapper: {
              draft: {
                  name: '草稿',
                  color: 'grey',
              },
              running: {
                  name: '發布',
                  color: 'orange',
              },
              disable: {
                  name: '結束',
                  color: 'green'
              }
          },
          modes: [
              {
                  id: 'all',
                  title: '全部'
              },
              {
                  id: 'draft',
                  title: '草稿'
              },
              {
                  id: 'running',
                  title: '發布'
              },
              {
                  id: 'disable',
                  title: '結束'
              }
          ]
        }
      }
    }, 
    created: async function(){
      this.getData()
    },
    mounted: function(){
        console.log('List')
    },
    methods: {
      async getData(){
        // 先抓網址上的頁碼，沒有預設就帶1
        let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
        let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.selected_per_page.value
        let search = this.$route.query.keyword ? this.$route.query.keyword : ''
        let query_mode = this.$route.query.mode ? this.$route.query.mode : ''
        console.log('page_idx', page_idx)
        console.log('limit', limit)
        this.search = search
        if (isNaN(limit)) {
          limit = 10
        }

        if (isNaN(page_idx)) {
          page_idx = 1
        }
        let match_mode_idx = this.tab_setting.modes.findIndex(function(mode){
            return mode.id === query_mode
        })

        if (match_mode_idx !== -1) {
            this.tab_setting.tab = match_mode_idx
        }
        else {
            this.tab_setting.tab = 0
        }
        this.loading = true
        try {
          let result = await apiGetSetting(
            this.$route.params.org_id, this.$route.params.container_id,
            search, limit, page_idx,this.tab_setting.modes[this.tab_setting.tab].id
          )
          let data = result.data
          console.log('data', data.content)
          this.items = data.content
					this.page_setting = {
						is_show: true,
						selected_page: page_idx,
						total_page: data.totalPages,
						total_visible: 10,
					}
					this.selected_per_page = {
						name: `${limit}筆`,
						value: limit, 
					}

          console.log('items', this.items)
        } catch (error) {
					let message = '取得資料失敗，原因: '
          if (error.includes('401') || error.includes('403')) {
            this.$root.vtoast.show({
              message: `沒有權限使用此功能，原因: ${error}`
            })
            this.$router.push(`/${this.$route.params.org_id}/401`)
          }
          else {
            message += error
            this.$root.vtoast.show({
              message: message
            })
          }

        }
        this.loading = false
      },
      createSetting: function(){
        this.dialog = true
        // this.$router.push(`new`)
      },
      viewSetting: function(item){
        this.$router.push(`${item.id}`)
      },
			async searchKeyword(keyword){
				console.log('keyword:', keyword)
				let query = this.$route.query;
				let tmp_query = {...query, limit: this.selected_per_page.value, page: 1, keyword: keyword};
				console.log(tmp_query)
				try {
					await this.$router.push({ path: this.$route.path, query: tmp_query})
				} catch (err) {
					console.log('ex')
					console.log('err.name', err.name)
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				}

        await this.getData()
			},
      disableEndtAt(date){
        let tmp_start_at = this.config.start_at.value
        tmp_start_at = tmp_start_at.replace(/-/g,'/')
        let start_at = new Date(tmp_start_at)
        return date < start_at;
      },
      disableCampaignStartAt(date){
        let tmp_start_at = this.config.start_at.value
        tmp_start_at = tmp_start_at.replace(/-/g,'/')
        let start_at = new Date(tmp_start_at)

        let tmp_end_at = this.config.end_at.value
        tmp_end_at = tmp_end_at.replace(/-/g,'/') 
        let end_at = new Date(tmp_end_at)

        return date < (start_at - 1000 * 60 * 60 * 24) || date > end_at;
      },
      disableCampaignEndAt(date){
        let tmp_start_at = this.config.campaign_start_at.value
        tmp_start_at = tmp_start_at.replace(/-/g,'/')
        let start_at = new Date(tmp_start_at)

        let tmp_end_at = this.config.end_at.value
        tmp_end_at = tmp_end_at.replace(/-/g,'/') 
        let end_at = new Date(tmp_end_at)

        return date < start_at || date > end_at;
      },
      sameTime(){
        console.log(this.same_checkbox)
        if (this.same_checkbox) {
          this.config.campaign_start_at.value = this.config.start_at.value
          this.config.campaign_end_at.value = this.config.end_at.value
        }
      },
      async confirmCreateSetting(){
        // 驗證欄位
        let result = this.$refs.form.validate();
        console.log(result)

        // 驗證時間
        let checks = []
        if (!this.config.start_at.value) {
          this.config.start_at.message = '必填欄位'
          checks.push(false)
        }
        else {
          this.config.start_at.message = ''
        }
        if (!this.config.end_at.value) {
          this.config.end_at.message = '必填欄位'
          checks.push(false)
        }
        else {
          this.config.end_at.message = ''
        }
        if (this.config.start_at.value && this.config.end_at.value) {
          let time1 = new Date(this.config.start_at.value).getTime()
          let time2 = new Date(this.config.end_at.value).getTime()
          if (time1 > time2) {
            this.config.end_at.message = '結束時間不能比開始時間早'
            checks.push(false)
          }
        }

        if (result === false || checks.includes(false)) {
          this.$root.vtoast.show({
            message: '請填寫完必填的欄位，再進行下一步的設定'
          })
          return
        }

        // 檢查是否有重複的urlview設定 + 實驗設定檔
        let is_duplicate = true
        try {
          let start_at =  this.$utils.toIsoString(this.config.start_at.value)
          let end_at = this.$utils.toIsoString(this.config.end_at.value)
          let params = {
            "start_at": start_at ,
            "end_at": end_at,
            "container_id": this.$route.params.container_id,
            "url": this.config.url.value
          }

          let check = await apiOverlaySetting(
            this.$route.params.org_id, params
          )
          console.log('check:', check)
          let count = check.data.urlview.length + check.data.experience.length
          if (count <= 0) {
            is_duplicate = false
          }
          this.duplicate_setting['urlview'] = check.data.urlview
          this.duplicate_setting['experience'] = check.data.experience
        } catch (error) {
          this.$root.vtoast.show({
            message: `檢查設定檔重複失敗，原因: ${error}` 
          })
        }
        this.is_duplicate = is_duplicate
        if (this.is_duplicate) {
          return
        }
        console.log('pass', this.config)

        try {
          let start_at =  this.$utils.toIsoString(this.config.start_at.value)
          let end_at = this.$utils.toIsoString(this.config.end_at.value)
          let params = {
            "url": this.config.url.value,
            "name": this.config.name.value,
            "container_id": this.$route.params.container_id,
            "start_at": start_at,
            "end_at": end_at,
            "campaign_start_at": start_at,
            "campaign_end_at": end_at,
            "add_column": "",
            "is_referer": false
          }
          let result = await apiCreateSetting(
            this.$route.params.org_id, params
          )
          console.log('result:', result)
          this.$root.vtoast.show({
            message: `新增設定檔成功！` 
          })
          let that = this
          setTimeout(function(){
            that.$router.push(`${result.data.id}`)
          },1000)
        } catch (error) {
          this.$root.vtoast.show({
            message: `新增設定檔失敗，原因: ${error}` 
          })
        }
        this.dialog = false
      },
      viewInfo(item, type, id){
        console.log('item', item)
        console.log('type', type)
        console.log('id', id)
        let path = ''
        if (type === 'experience') {
          path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/experiments/${id}`
          console.log(path)
        }
        if (path) {
          window.open(path,'_blank')
        }
      },
      async deleteSetting(item){
        let is_confirm = confirm(`確定刪除 ${item.name} 這個衝動外掛設定檔？`)
        if (!is_confirm) {
          return
        }
        try {
          let result = await apiDeleteSetting(this.$route.params.org_id, item.id)
          console.log('result', result)
          this.$root.vtoast.show({
            message: `刪除成功` 
          })
        } catch (error) {
          this.$root.vtoast.show({
            message: `刪除設定檔失敗，原因: ${error}` 
          })
        }
        await this.getData()
      },
      async changePageCallback(page){
        console.log('changePage', page)
        this.page_setting.selected_page = page
        await this.getData()
      },
			chagePerPage: async function(selected_per_page){
				let query = this.$route.query;
				let tmp_query = {...query, limit: selected_per_page.value, page: 1};
				console.log(tmp_query)
				try {
					await this.$router.replace({ path: this.$route.path, query: tmp_query})
				} catch (err) {
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				}
        await this.getData()
			},
      async changeTab(item){
          console.log('item', item)
          let query = this.$route.query;
          let tmp_query = {...query, 
              limit: this.selected_per_page.value,
              page: 1, keyword: '', mode:item.id
          };
          console.log(tmp_query)
          try {
              await this.$router.replace({ 
                path: this.$route.path,
                query: tmp_query
              })
              await this.getData()
          } catch (err) {
            console.log('ex')
            console.log('err.name', err.name)
            if (err.name !== 'NavigationDuplicated') {
                throw err;
            }
          }
      },
      async copyUrlView(item){
        console.log(apiCopyUrlView)
        console.log(item)
        try {
          let result = await apiCopyUrlView(
            this.$route.params.org_id, item.id
          )
          console.log('result', result)
          this.$root.vtoast.show({
            color: 'primary',
            message: `複製設定檔成功！` 
          })
          this.$router.push(`/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/page_plugin/${result.data.urlView.id}`)
        } catch (error) {
          this.$root.vtoast.show({
            message: `複製設定檔失敗，原因: ${error}` 
          })
        }
      }
    },
    watch: {
    },
    computed: {
    }     
  }
</script>
<style scoped>
h4 {
    color: #5b5b5b;
}
</style>